export function eddDefaultOffset(str: string): Date {
  let res = new Date(str);
  const offset = res.getTimezoneOffset();
  res = new Date(res.getTime() + offset * 60 * 1000);
  return res;
}

export function prepareEDDValue(date: Date): string {
  const offset = date.getTimezoneOffset();
  const eddDate = new Date(date.getTime() - offset * 60 * 1000);
  return eddDate.toISOString().split("T")[0];
}

export function convertDateToUTC(date: Date): Date {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
}

export const DATE_TIME_FORMAT = "ddd M/D/YYYY [at] HH:mm";

export const DATE_FORMAT = "ddd M/D/YYYY";
